/**
 * Sign Up Page
 * ShiftCheck Marketing Website
 *
 * Signup now happens on the app domain (app.shiftcheck.app/signup).
 * This route only exists to catch old links/bookmarks and forward them.
 */

import { useEffect } from 'react';

export default function SignUpPage() {
  useEffect(() => {
    window.location.href = 'https://app.shiftcheck.app/signup';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <p className="text-sm text-gray-500">Redirecting…</p>
    </div>
  );
}
